(function(angular){
    'use strict';

    angular.module('onvio.setup.appearance').directive('signInOptionsForm', [function(){
        return {
            restrict: 'E',
            replace: true,
            scope: {
                optionsData: '='
            },
            templateUrl: 'setup/src/themes/sign-in-options.2js.html',
            controller: 'SignInOptionsCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }]);
})(window.angular);
